import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForgotPasswordDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 141,
	viewBox: "0 0 412 141",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0426 97.1746C43.8326 97.1846 43.6226 97.1346 43.4326 97.0047C42.9826 96.6947 42.8626 96.0845 43.1726 95.6345L48.9326 87.1946C49.1026 86.9446 49.3826 86.7845 49.6826 86.7645C49.9626 86.7345 50.2826 86.8646 50.4826 87.0846L54.2026 91.1746L60.8726 80.1345C61.0326 79.8745 61.2926 79.7046 61.5926 79.6646C61.8926 79.6346 62.1926 79.7346 62.4126 79.9446L66.4626 83.9746L75.0126 71.4346C75.3226 70.9846 75.9326 70.8646 76.3826 71.1746C76.8326 71.4846 76.9527 72.0946 76.6427 72.5446L67.4326 86.0646C67.2726 86.3046 67.0026 86.4646 66.7126 86.4946C66.4026 86.5346 66.1326 86.4146 65.9226 86.2146L61.9226 82.2346L55.2226 93.3346C55.0626 93.6046 54.7826 93.7746 54.4726 93.8046C54.1426 93.8446 53.8526 93.7146 53.6426 93.4846L49.8726 89.3446L44.8226 96.7547C44.6426 97.0147 44.3526 97.1646 44.0626 97.1846L44.0426 97.1746Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 31.4395,
			x2: 17.1012,
			y2: 46.4395,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 60.8112,
			y2: -.45,
			transform: "matrix(0.707107 0.707107 0.707107 -0.707107 95 35.001)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 56.001C13.4183 56.001 17 52.4193 17 48.001C17 43.5827 13.4183 40.001 8.99999 40.001C4.58171 40.001 1 43.5827 1 48.001C1 52.4193 4.58171 56.001 8.99999 56.001Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 51.001C10.6568 51.001 12 49.6578 12 48.001C12 46.3441 10.6568 45.001 8.99999 45.001C7.34313 45.001 6 46.3441 6 48.001C6 49.6578 7.34313 51.001 8.99999 51.001Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 37.002C94.4183 37.002 98 33.4202 98 29.002C98 24.5837 94.4183 21.002 90 21.002C85.5817 21.002 82 24.5837 82 29.002C82 33.4202 85.5817 37.002 90 37.002Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 32.002C91.6569 32.002 93 30.6588 93 29.002C93 27.3451 91.6569 26.002 90 26.002C88.3431 26.002 87 27.3451 87 29.002C87 30.6588 88.3431 32.002 90 32.002Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 129.002)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 63.002)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 126.002)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 55.002C336.418 55.002 340 58.5837 340 63.0019C340 67.4202 336.418 71.002 332 71.002C327.582 71.002 324 67.4202 324 63.0019C324 58.5837 327.582 55.002 332 55.002Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 60.002C333.657 60.002 335 61.3451 335 63.002C335 64.6588 333.657 66.002 332 66.002C330.343 66.002 329 64.6588 329 63.002C329 61.3451 330.343 60.002 332 60.002Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 63.002C407.418 63.002 411 66.5837 411 71.002C411 75.4202 407.418 79.002 403 79.002C398.582 79.002 395 75.4202 395 71.002C395 66.5837 398.582 63.002 403 63.002Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 68.002C404.657 68.002 406 69.3451 406 71.002C406 72.6588 404.657 74.002 403 74.002C401.343 74.002 400 72.6588 400 71.002C400 69.3451 401.343 68.002 403 68.002Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 124.002C296.418 124.002 300 127.584 300 132.002C300 136.42 296.418 140.002 292 140.002C287.582 140.002 284 136.42 284 132.002C284 127.584 287.582 124.002 292 124.002Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 129.002C293.657 129.002 295 130.345 295 132.002C295 133.659 293.657 135.002 292 135.002C290.343 135.002 289 133.659 289 132.002C289 130.345 290.343 129.002 292 129.002Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.2999 18.6519C39.2999 20.6719 37.6699 22.3019 35.6499 22.3019C33.6299 22.3019 32 20.6719 32 18.6519C32 16.6319 33.6299 15.002 35.6499 15.002C37.6699 15.002 39.2999 16.6319 39.2999 18.6519Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M351.3 100.652C351.3 102.672 349.67 104.302 347.65 104.302C345.63 104.302 344 102.672 344 100.652C344 98.6319 345.63 97.002 347.65 97.002C349.67 97.002 351.3 98.6319 351.3 100.652Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M317 60C314.786 45.2734 300.906 35.1085 286 37.2962",
			stroke: "#F2B014",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 121,
			width: 170,
			height: 112,
			rx: 8,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 125,
			y: 4,
			width: 162,
			height: 93,
			rx: 4,
			fill: "#1C1C1E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.15 104.2C209.15 105.971 207.715 107.4 205.95 107.4C204.185 107.4 202.75 105.965 202.75 104.2C202.75 102.435 204.185 101 205.95 101C207.715 101 209.15 102.435 209.15 104.2Z",
			stroke: "#9F9FA5",
			strokeWidth: .9,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.881 133C172.881 129.465 175.746 126.6 179.281 126.6H230.481C234.015 126.6 236.881 129.465 236.881 133H172.881Z",
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 187.816,
			y: 111.667,
			width: 34.1333,
			height: 14.9333,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.083 118.067C203.389 115.08 192.616 114.334 187.816 114.334V111.667H221.949V126.6H219.816C217.861 125 212.776 121.054 208.083 118.067Z",
			fill: "#989899"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129 97C126.791 97 125 95.2091 125 93L125 8C125 5.79086 126.791 4 129 4L156 4L156 97L129 97Z",
			fill: "#131314"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.5 10H137.244L137.169 10.0008C136.937 9.99669 136.853 10.0863 136.784 10.197L135.798 11.7129L134.853 10.2274L134.821 10.1787C134.821 10.1787 134.796 10.1353 134.75 10.1337H134.75C134.705 10.1353 134.679 10.1787 134.679 10.1787L134.647 10.2274L133.735 11.7129L132.717 10.197C132.647 10.0863 132.563 9.99669 132.331 10.0008L132.256 10H131L131.001 11.2378H131.74C131.896 11.2363 131.968 11.2438 132.075 11.3769L132.119 11.4442L133.613 13.8679C133.613 13.8679 133.662 13.9462 133.744 13.9467C133.833 13.947 133.882 13.8677 133.882 13.8677L134.752 12.5154H134.752L135.656 13.8659C135.656 13.8659 135.707 13.946 135.784 13.948C135.867 13.9501 135.912 13.8677 135.912 13.8677L137.383 11.4442L137.427 11.3769C137.503 11.2529 137.6 11.2399 137.755 11.2414L138.495 11.2409L138.5 10Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.609 13.4407L135.805 14.7642L134.768 13.2049L133.97 14.4494L135.654 17.186C135.712 17.2617 135.758 17.2776 135.782 17.2784C135.833 17.2807 135.862 17.2524 135.917 17.1567L137.237 14.6578C137.354 14.4407 137.55 14.4435 137.55 14.4435H138.503L138.502 13.2074H137.015C136.744 13.2074 136.609 13.4407 136.609 13.4407Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 136.95,
			y1: 25.45,
			x2: 131.45,
			y2: 25.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 141.22,
			y1: 30.45,
			x2: 131.453,
			y2: 30.45,
			stroke: "#F2B014",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 136.95,
			y1: 35.45,
			x2: 131.45,
			y2: 35.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 141.22,
			y1: 40.45,
			x2: 131.453,
			y2: 40.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 136.95,
			y1: 45.45,
			x2: 131.45,
			y2: 45.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 141.22,
			y1: 50.45,
			x2: 131.453,
			y2: 50.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.45,
			y: 25.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 176,
			y: 43,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 191.55,
			y1: 36.45,
			x2: 180.45,
			y2: 36.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 195.55,
			y1: 31.45,
			x2: 176.45,
			y2: 31.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 206.45,
			y: 25.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 210,
			y: 43,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 225.55,
			y1: 36.45,
			x2: 214.45,
			y2: 36.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 229.55,
			y1: 31.45,
			x2: 210.45,
			y2: 31.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 240.45,
			y: 25.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 244,
			y: 43,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 259.55,
			y1: 36.45,
			x2: 248.45,
			y2: 36.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 263.55,
			y1: 31.45,
			x2: 244.45,
			y2: 31.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.45,
			y: 57.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 176,
			y: 75,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 191.55,
			y1: 68.45,
			x2: 180.45,
			y2: 68.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 195.55,
			y1: 63.45,
			x2: 176.45,
			y2: 63.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 206.45,
			y: 57.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 210,
			y: 75,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 225.55,
			y1: 68.45,
			x2: 214.45,
			y2: 68.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 229.55,
			y1: 63.45,
			x2: 210.45,
			y2: 63.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 240.45,
			y: 57.45,
			width: 27.1,
			height: 25.1,
			rx: 2.55,
			stroke: "#464649",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 244,
			y: 75,
			width: 20,
			height: 4,
			rx: 2,
			fill: "#F2C24F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 259.55,
			y1: 68.45,
			x2: 248.45,
			y2: 68.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 263.55,
			y1: 63.45,
			x2: 244.45,
			y2: 63.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 237.55,
			y1: 16.45,
			x2: 172.45,
			y2: 16.45,
			stroke: "#464649",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.781 96.734C115.781 107.934 119.734 117.148 134.321 117.213",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			opacity: .5,
			cx: 289.499,
			cy: 63.4998,
			r: 19.5,
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 289.499,
			cy: 63.4998,
			r: 14.5,
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M283.999 63.2389L288.54 67.4998L295.999 60.4998",
			stroke: "#2C2C2E",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.043 21.012C346.833 21.002 346.623 21.0519 346.433 21.1819C345.983 21.4919 345.863 22.102 346.173 22.552L351.933 30.9919C352.103 31.2419 352.383 31.402 352.683 31.422C352.963 31.452 353.283 31.3219 353.483 31.1019L357.203 27.012L363.873 38.052C364.033 38.312 364.293 38.482 364.593 38.522C364.893 38.552 365.193 38.452 365.413 38.242L369.463 34.2119L370.5 33.1846C370.628 32.9263 370.593 32.362 370.433 32.122C370.273 31.882 370.003 31.7219 369.713 31.6919C369.403 31.6519 369.133 31.7719 368.923 31.9719L364.923 35.9519L358.223 24.8519C358.063 24.5819 357.783 24.412 357.473 24.382C357.143 24.342 356.853 24.4719 356.643 24.7019L352.873 28.8419L347.823 21.4319C347.643 21.1719 347.353 21.022 347.063 21.002L347.043 21.012Z",
			fill: "#40C676"
		})
	]
});
const ForwardRef = forwardRef(SvgForgotPasswordDark);
export default ForwardRef;
